import $ from 'jquery';
import { $videos } from './variables';

// modules 
// video
if ($('.video').length !== 0) {
  $('.video').on('click', function () {
    if ($('.thumbnail', this).length !== 0) {
      let transition_in_ms = 1000;
      $('.thumbnail', this).css('opacity', '0');
      $('.video-icon', this).css('opacity', '0');

      setTimeout(function () {
        $('.thumbnail', this).remove();
        $('.video-icon', this).remove();
      }, transition_in_ms)

    }

    if ($('iframe', this).length) {
      let src = $('iframe', this).attr('src');
      if (src && !src.includes('autoplay')) {
        $('iframe', this).attr('src', src + "?autoplay=1");
      }
    }
    if ($('video', this).length) {
      // @ts-ignore
      $('video', this).get(0).play();
    }

  })
}

if ($videos.length) {

  $videos.each((index, elem) => {
    // wrap the container inside a jquery element for consistent, uniform readability
    let $videoContainer = $(elem);

    // get the video to enable its functions 
    let $video = $('.js__video', elem);

    // handle click on container to also get the click on the icon 
    $videoContainer.on('click', () => {

      // remove thumbnail from video  
      $video.removeAttr('poster');

      // show the controls bar to start and stop videos 
      $video.attr('controls', 'true');
      $video.attr('autoplay', 'true');

      // hide the play icon when starting on video 
      $('.js__video_icon', elem).hide();

      // start the video 
      $video.trigger('play');

      // remove eventlistener to avoid unwanted play and pause behaviour 
      $videoContainer.off();

    });
  });
}
